<template>
  <Dialog
    v-model:open="showUpgradeProgressDialog"
    description=""
    :close-on-overlay-click="false"
    content-class="w-145 p-6 gap-6"
  >
    <rocketProgress v-model="firmwareUpgradeProgress" />
    <div class="w-full">
      <div class="text-s-medium w-full text-center text-text-glass-default">
        {{ t('setting.device.firmware.upgradingText')
        }}<span class="text-brand-blue1">{{ firmwareUpgradeProgress }}</span> / 100
      </div>
      <div class="text-s-medium w-full text-center text-text-glass-default">
        {{ t('setting.device.firmware.upgradingTipText') }}
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { Dialog } from '@rapoo/element'
  import { useFirmwareStore, useLocaleStore } from '@/stores'
  import rocketProgress from '@/components/rocketProgress/index.vue'

  const { t } = useLocaleStore()
  const firmwareStore = useFirmwareStore()
  const { showUpgradeProgressDialog, firmwareUpgradeProgress } = storeToRefs(firmwareStore)
</script>
